import { ManagementLoginApprovalComponent } from "@/app/infrastructures/dependencies/modules/ManagementLoginApprovalComponent";
import { ManagementLoginApprovalPresenter } from "@/app/ui/presenters/ManagementLoginApprovalPresenter";
import { LoginApprovalDeleteReviewBody, LoginApprovalDeviceRequest, LoginApprovalDevicesList, LoginApprovalHistoryList, LoginApprovalHistoryRequest, LoginApprovalList, LoginApprovalRequest, LoginReviewBody, LoginReviewError, LoginReviewSuccess } from "@/domain/entities/ManagementLoginApproval";
import store from "@/store";
import { container } from "tsyringe";
import { Action, getModule, Module, Mutation, VuexModule } from "vuex-module-decorators";
import { MainAppController } from "./MainAppController";
import { ResponsePayloadV2 } from "@/domain/entities/ResponsePayload";

ManagementLoginApprovalComponent.init();

@Module({
  namespaced: true,
  dynamic: true,
  store,
  name: "management-login-approval"
})
class ManagementLoginApprovalStore extends VuexModule {
  // approval
  @Action
  public getLoginRequests(
    params: LoginApprovalRequest
  ): Promise<LoginApprovalList> {
    const presenter = container.resolve(ManagementLoginApprovalPresenter);
    return presenter.getLoginApprovalList(params).then((res) => {
      // show icon notification based on list data, if list no data, then false
      MainAppController.setShowIconNotificationMenuSidebar(
        Boolean(res.data.length)
      );

      return res;
    });
  }

  @Action
  public postLoginApprovalReview(params: LoginReviewBody): Promise<ResponsePayloadV2> {
    const presenter = container.resolve(ManagementLoginApprovalPresenter);
    return presenter.postLoginApprovalReview(params);
  }

  // devices
  @Action
  public getLoginDevicesList(params: LoginApprovalDeviceRequest): Promise<LoginApprovalDevicesList> {
    const presenter = container.resolve(ManagementLoginApprovalPresenter);
    return presenter.getLoginApprovalDevicesList(params);
  }

  @Action
  public postLoginApprovalDeviceDelete(params: LoginApprovalDeleteReviewBody): Promise<boolean> {
    const presenter = container.resolve(ManagementLoginApprovalPresenter);
    return presenter.postLoginApprovalDeviceDelete(params);
  }

  // history
  @Action
  public getLoginHistoryList(params: LoginApprovalHistoryRequest): Promise<LoginApprovalHistoryList> {
    const presenter = container.resolve(ManagementLoginApprovalPresenter);
    return presenter.getLoginApprovalHistoryList(params);
  }

  refreshList = false;
  @Mutation
  public setRefreshList(value: boolean) {
    this.refreshList = value;
  }
}

export const ManagementLoginApprovalController = getModule(
  ManagementLoginApprovalStore
);
